(() => {
  const root = document.querySelector('[data-royal-min3]');
  if (!root || root.dataset.royalMin3Ready) return;
  root.dataset.royalMin3Ready = 'true';
  const minimum = 5;
  const giftMinimum = 5;
  const selected = new Map();
  let cards = [...root.querySelectorAll('[data-royal-min3-product]')];
  const submit = root.querySelector('[data-royal-min3-submit]');
  const error = root.querySelector('[data-royal-min3-error]');
  const list = root.querySelector('[data-royal-min3-selected-list]');
  let busy = false;
  let committed = false;
  let uncertain = false;
  let attempt = null;
  let snapshot = [];
  let previousKeys = new Set();
  const stateKey = 'royal-min3-selection-v2';
  const returnKey = 'royal-min3-return-url';
  const saveSelection = () => {
    try {
      window.sessionStorage.setItem(stateKey, JSON.stringify({
        savedAt: Date.now(), selected: [...selected], committed, uncertain, attempt, snapshot
      }));
      return true;
    } catch { return false; }
  };
  try {
    const saved = JSON.parse(window.sessionStorage.getItem(stateKey) || 'null');
    if (saved && Date.now() - saved.savedAt < 86400000 && Array.isArray(saved.selected)) {
      for (const [id, item] of saved.selected) {
        if (item && String(item.productId) === String(id) && /^\d+$/.test(String(item.variantId))) selected.set(String(id), item);
      }
      committed = saved.committed === true;
      uncertain = saved.uncertain === true;
      attempt = typeof saved.attempt === 'string' ? saved.attempt : null;
      snapshot = Array.isArray(saved.snapshot) ? saved.snapshot : [];
      for (const card of cards) {
        const item = selected.get(card.dataset.royalMin3Product);
        if (item) card.querySelector('[data-royal-min3-variant]').value = item.variantId;
      }
    }
  } catch {}
  root.addEventListener('click', (event) => {
    const link = event.target.closest('a.royal-min3-image-wrap, a.royal-min3-product-link');
    if (!link || !root.contains(link)) return;
    if (busy || uncertain) { event.preventDefault(); return; }
    try {
      if (!saveSelection()) throw new Error('storage');
      window.sessionStorage.setItem(returnKey, window.location.href);
    } catch {
      if (selected.size) {
        event.preventDefault();
        message('Deine Auswahl konnte nicht gespeichert werden. Bitte erlaube den Sitzungsspeicher, bevor du die Produktdetails öffnest.');
      }
    }
  });
  const readJSON = async (url, options = {}) => {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    let data;
    try { data = await response.json(); } catch { throw new Error('response'); }
    if (!response.ok) {
      const failure = new Error('request');
      failure.status = response.status;
      throw failure;
    }
    return data;
  };
  const post = (url, body) => readJSON(url, {
    method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body)
  });
  const message = (text) => {
    error.textContent = text;
    error.hidden = !text;
    if (text) error.focus();
  };
  const render = () => {
    saveSelection();
    const count = selected.size;
    const unlocked = count >= minimum;
    root.querySelector('[data-royal-min3-status]').textContent = unlocked ? 'Freigeschaltet ✓' : count === 0 ? `0 von ${minimum} ausgewählt` : `Nur noch ${minimum - count} ${minimum - count === 1 ? 'Schmuckstück' : 'Schmuckstücke'}`;
    root.querySelector('[data-royal-min3-unlock]').hidden = !unlocked;
    root.querySelector('[data-royal-min3-unlock]').textContent = count >= giftMinimum ? 'Deine kostenlose Schmuckbox ist freigeschaltet 🎁' : 'Wähle ein 6. Schmuckstück und erhalte eine Schmuckbox gratis 🎁';
    root.querySelector('[data-royal-min3-gift-label]').hidden = count < giftMinimum;
    root.querySelector('[data-royal-min3-progress]').classList.toggle('royal-min3-unlocked', unlocked);
    root.querySelectorAll('.royal-min3-dot').forEach((dot, index) => { dot.textContent = index < count ? '●' : '○'; });
    root.querySelector('[data-royal-min3-count]').textContent = `${count}/${minimum} ausgewählt`;
    submit.textContent = busy ? 'Auswahl wird gesichert …' : uncertain ? 'Warenkorb prüfen' : !unlocked ? `${count}/${minimum} ausgewählt` : committed ? 'Meine Auswahl aktualisieren' : 'Meine Auswahl sichern';
    submit.disabled = busy || !unlocked;
    root.setAttribute('aria-busy', String(busy));
    list.replaceChildren();
    root.querySelector('[data-royal-min3-selection]').hidden = count === 0;
    for (const [id, item] of selected) {
      const entry = document.createElement('li');
      entry.className = 'royal-min3-selected-item';
      const name = document.createElement('span');
      name.textContent = item.title + (item.variantTitle ? ` · ${item.variantTitle}` : '');
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'royal-min3-remove';
      remove.dataset.royalMin3Remove = id;
      remove.textContent = 'Entfernen';
      remove.setAttribute('aria-label', `${item.title} entfernen`);
      remove.disabled = busy || uncertain;
      entry.append(name, remove);
      list.append(entry);
    }
    for (const card of cards) {
      const active = selected.has(card.dataset.royalMin3Product);
      const variant = card.querySelector('[data-royal-min3-variant]');
      const pick = card.querySelector('[data-royal-min3-pick]');
      card.classList.toggle('royal-min3-selected', active);
      card.querySelector('.royal-min3-selected-mark').hidden = !active;
      pick.setAttribute('aria-pressed', String(active));
      pick.setAttribute('aria-label', `${card.dataset.royalMin3Title} ${active ? 'entfernen' : 'auswählen'}`);
      pick.textContent = active ? 'Entfernen ✕' : variant.value ? 'Auswählen' : variant.tagName === 'SELECT' && [...variant.options].some(option => option.value && !option.disabled) ? 'Auswählen' : 'Ausverkauft';
      pick.disabled = busy || uncertain || (!active && !variant.value);
      if (variant.tagName === 'SELECT') variant.disabled = busy || uncertain || active || ![...variant.options].some(option => option.value && !option.disabled);
    }
  };
  root.addEventListener('change', (event) => {
    if (event.target.matches('[data-royal-min3-variant]')) render();
  });
  const refreshAvailability = async () => {
    let replaced = 0;
    await Promise.all([...selected].map(async ([id, item]) => {
      const product = await readJSON(`${root.dataset.productRoot}${encodeURIComponent(item.handle)}.js`);
      const variant = product.variants.find(candidate => String(candidate.id) === item.variantId);
      if (!variant || !variant.available) {
        selected.delete(id);
        replaced += 1;
        const card = cards.find(candidate => candidate.dataset.royalMin3Product === id);
        if (!card) return;
        const control = card.querySelector('[data-royal-min3-variant]');
        if (control.tagName === 'SELECT') {
          for (const option of control.options) {
            if (option.value) option.disabled = !product.variants.some(candidate => String(candidate.id) === option.value && candidate.available);
          }
        }
        control.value = '';
      }
    }));
    return replaced;
  };
  const attemptLines = (cart) => cart.items.filter(item => item.properties?._royal_min3_attempt === attempt);
  const reconcile = async () => {
    const cart = await readJSON(root.dataset.cartUrl);
    const lines = attemptLines(cart);
    const found = new Set(lines.filter(item => item.properties?._royal_min3_test === 'B').map(item => String(item.variant_id)));
    const giftFound = snapshot.length < giftMinimum || !root.dataset.giftVariantId || cart.items.some(item => String(item.variant_id) === root.dataset.giftVariantId && item.quantity > 0);
    if (snapshot.every(item => found.has(item.variantId)) && giftFound) {
      committed = true;
      uncertain = false;
      return cart;
    }
    if (lines.length) {
      uncertain = true;
      throw new Error('partial');
    }
    return null;
  };
  const updateAndCheckout = async () => {
    const cart = await readJSON(root.dataset.cartUrl);
    const distinct = new Set(cart.items.filter(item => item.properties?._royal_min3_test === 'B').map(item => String(item.product_id)));
    const variants = new Set(attemptLines(cart).filter(item => item.properties?._royal_min3_test === 'B').map(item => String(item.variant_id)));
    if (distinct.size < minimum || !snapshot.every(item => variants.has(item.variantId))) throw new Error('cart-changed');
    if (snapshot.length >= giftMinimum && root.dataset.giftVariantId && !cart.items.some(item => String(item.variant_id) === root.dataset.giftVariantId && item.quantity > 0)) throw new Error('gift');
    await post(root.dataset.updateUrl, { attributes: {
      royal_ab_test: 'min3', royal_ab_version: 'B', royal_ab_landing: 'waehle-3',
      royal_required_count: String(minimum), royal_selected_count: String(selected.size), royal_surprise_gift: selected.size >= giftMinimum ? 'unlocked' : 'locked'
    } });
    if (
  typeof window.upcartRefreshCart !== 'function' ||
  typeof window.upcartOpenCart !== 'function'
) {
  throw new Error('upcart');
}

await window.upcartRefreshCart();
await window.upcartOpenCart();
  };
  const secureSelection = async () => {
    if (busy || selected.size < minimum) return;
    busy = true;
    message('');
    render();
    try {
      if (uncertain) {
        if (!await reconcile()) throw new Error('unknown');
      }
      {
        const changed = await refreshAvailability();
        if (changed || selected.size < minimum) throw new Error('availability');
        snapshot = [...selected.values()];
        const originalCart = await readJSON(root.dataset.cartUrl);
        if (!attempt) attempt = crypto.randomUUID();
        const existingVariants = new Set(attemptLines(originalCart).filter(item => item.properties?._royal_min3_test === 'B').map(item => String(item.variant_id)));
        const items = snapshot.filter(item => !existingVariants.has(item.variantId)).map(item => ({ id: item.variantId, quantity: 1, properties: {
          _royal_min3_test: 'B', _royal_min3_attempt: attempt
        } }));
        const gift = root.dataset.giftVariantId;
        if (gift && snapshot.length >= giftMinimum && !originalCart.items.some(item => String(item.variant_id) === gift && item.quantity > 0)) {
          if (!/^\d+$/.test(gift)) throw new Error('gift');
          items.push({ id: gift, quantity: 1, properties: { _royal_min3_gift: 'B', _royal_min3_attempt: attempt } });
        }
        try {
          if (items.length) await post(root.dataset.addUrl, { items });
          committed = true;
        } catch (failure) {
          const cart = await reconcile();
          if (!cart) {
            if (!failure.status || failure.status >= 500) {
              uncertain = true;
              throw new Error('unknown');
            }
            if (failure.status === 422) {
              await refreshAvailability();
              throw new Error('availability');
            }
            throw new Error('add');
          }
        }
      }
      await updateAndCheckout();
    } catch (failure) {
      const text = {
        availability: 'Ein ausgewähltes Schmuckstück oder eine Variante ist nicht mehr verfügbar. Bitte passe deine Auswahl an und versuche es erneut.',
        gift: 'Das Überraschungsgeschenk ist aktuell nicht verfügbar. Bitte versuche es später erneut.',
        add: 'Deine Auswahl konnte nicht hinzugefügt werden. Bitte prüfe deine Verbindung und versuche es erneut.',
        partial: 'Der Warenkorb konnte nur teilweise bestätigt werden. Bitte prüfe ihn über das Warenkorb-Symbol. Es werden keine Artikel automatisch erneut hinzugefügt.',
        unknown: 'Die Übertragung konnte nicht bestätigt werden. Prüfe bitte deinen Warenkorb. Mit „Warenkorb prüfen“ wird nur der Status geprüft, ohne Artikel erneut hinzuzufügen.',
        'cart-changed': 'Dein Warenkorb wurde zwischenzeitlich geändert. Bitte prüfe ihn über das Warenkorb-Symbol, bevor du fortfährst.'
      };
      message(text[failure.message] || (committed ? 'Deine Auswahl liegt bereits im Warenkorb. Bitte versuche „Meine Auswahl aktualisieren“ erneut; vorhandene Artikel werden nicht nochmals hinzugefügt.' : 'Deine Auswahl konnte nicht gesichert werden. Bitte prüfe deine Verbindung und versuche es erneut.'));
    } finally {
      busy = false;
      render();
    }
  };
  const removeSelection = async (id) => {
    if (busy || uncertain || !selected.has(id)) return;
    if (!attempt) {
      selected.delete(id);
      message('');
      render();
      return;
    }
    busy = true;
    message('');
    render();
    try {
      const cart = await readJSON(root.dataset.cartUrl);
      const ownedLines = attemptLines(cart);
      const removed = ownedLines.filter(item => item.properties?._royal_min3_test === 'B' && String(item.product_id) === id);
      if (selected.size - 1 < giftMinimum) removed.push(...ownedLines.filter(item => item.properties?._royal_min3_gift === 'B'));
      const removedKeys = new Set(removed.map(item => item.key));
      const remainingCount = new Set(cart.items.filter(item => !removedKeys.has(item.key) && item.properties?._royal_min3_test === 'B' && item.quantity > 0).map(item => String(item.product_id))).size;
      if (removed.length) {
        const updates = Object.fromEntries(removed.map(item => [item.key, 0]));
        const attributes = { royal_selected_count: String(remainingCount), royal_surprise_gift: remainingCount >= giftMinimum ? 'unlocked' : 'locked' };
        try {
          await post(root.dataset.updateUrl, { updates, attributes });
        } catch (failure) {
          const confirmed = await readJSON(root.dataset.cartUrl);
          if (attemptLines(confirmed).some(item => item.properties?._royal_min3_test === 'B' && String(item.product_id) === id) || (selected.size - 1 < giftMinimum && attemptLines(confirmed).some(item => item.properties?._royal_min3_gift === 'B'))) throw failure;
          await post(root.dataset.updateUrl, { attributes });
        }
      }
      selected.delete(id);
      snapshot = snapshot.filter(item => item.productId !== id);
      if (typeof window.upcartRefreshCart === 'function') {
        try { await window.upcartRefreshCart(); } catch { message('Dein Schmuckstück wurde entfernt. Öffne den Warenkorb erneut, um den aktuellen Stand zu sehen.'); }
      }
    } catch {
      message('Das Schmuckstück konnte nicht entfernt werden. Bitte prüfe deine Verbindung und versuche es erneut. Deine Auswahl bleibt erhalten.');
    } finally {
      busy = false;
      render();
    }
  };
  const grid = root.querySelector('[data-royal-min3-grid]');
  const catalogStatus = root.querySelector('[data-royal-min3-catalog-status]');
  const loadMore = root.querySelector('[data-royal-min3-load-more]');
  let activeCollection = root.querySelector('[data-royal-min3-collection][aria-pressed="true"]');
  let catalogBusy = false;
  let nextCatalogURL = null;
  const loadCollection = async (button, append = false) => {
    if (!button || catalogBusy || busy || uncertain) return;
    catalogBusy = true;
    const url = new URL(append ? nextCatalogURL : button.dataset.royalMin3Collection, window.location.origin);
    url.searchParams.set('view', 'royal-min3-catalog');
    // Retain Shopify's preview context only in staging. The landing URL and UTMs never change.
    const landingParams = new URLSearchParams(window.location.search);
    for (const key of ['preview_theme_id', '_ab', '_fd', '_sc']) {
      if (landingParams.has(key)) url.searchParams.set(key, landingParams.get(key));
    }
    catalogStatus.textContent = 'Kollektion wird geladen …';
    grid.setAttribute('aria-busy', 'true');
    root.querySelectorAll('[data-royal-min3-collection]').forEach(item => { item.disabled = true; });
    loadMore.disabled = true;
    try {
      const response = await fetch(url.href, { credentials: 'same-origin', headers: { Accept: 'text/html' } });
      if (!response.ok) throw new Error('catalog');
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const catalog = html.querySelector('[data-royal-min3-catalog]');
      if (!catalog) throw new Error('catalog');
      const incoming = [...catalog.querySelectorAll('[data-royal-min3-product]')];
      const currentIDs = new Set(append ? cards.map(card => card.dataset.royalMin3Product) : []);
      const nodes = incoming.filter(card => !currentIDs.has(card.dataset.royalMin3Product));
      if (!append) grid.replaceChildren();
      grid.append(...nodes);
      cards = [...grid.querySelectorAll('[data-royal-min3-product]')];
      for (const card of cards) {
        const item = selected.get(card.dataset.royalMin3Product);
        if (item) card.querySelector('[data-royal-min3-variant]').value = item.variantId;
      }
      activeCollection = button;
      root.querySelectorAll('[data-royal-min3-collection]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      root.querySelector('[data-royal-min3-grid-title]').textContent = button.dataset.royalMin3CollectionTitle;
      const next = html.querySelector('[data-royal-min3-next]');
      nextCatalogURL = next ? new URL(next.getAttribute('href'), url).href : null;
      loadMore.hidden = !nextCatalogURL;
      catalogStatus.textContent = cards.length ? `${button.dataset.royalMin3CollectionTitle}: ${cards.length} Schmuckstücke geladen. Deine Auswahl bleibt erhalten.` : 'Aktuell sind keine Schmuckstücke in dieser Kollektion verfügbar.';
      render();
    } catch {
      catalogStatus.textContent = 'Die Kollektion konnte nicht geladen werden. Bitte versuche es erneut. Deine Auswahl bleibt erhalten.';
    } finally {
      catalogBusy = false;
      grid.setAttribute('aria-busy', 'false');
      root.querySelectorAll('[data-royal-min3-collection]').forEach(item => { item.disabled = false; });
      loadMore.disabled = false;
    }
  };
  root.addEventListener('click', (event) => {
    const target = event.target.closest('button');
    if (!target || !root.contains(target) || target.disabled) return;
    if (target.matches('[data-royal-min3-collection]')) { loadCollection(target); return; }
    if (target.matches('[data-royal-min3-load-more]')) { loadCollection(activeCollection, true); return; }
    if (target.matches('[data-royal-min3-submit]')) { secureSelection(); return; }
    if (busy || uncertain) return;
    if (target.dataset.royalMin3Remove) {
      const id = target.dataset.royalMin3Remove;
      removeSelection(id);
      cards.find(card => card.dataset.royalMin3Product === id)?.querySelector('[data-royal-min3-pick]')?.focus();
      return;
    }
    if (!target.matches('[data-royal-min3-pick]')) return;
    const card = target.closest('[data-royal-min3-product]');
    const id = card.dataset.royalMin3Product;
    const variant = card.querySelector('[data-royal-min3-variant]');
    if (selected.has(id)) { removeSelection(id); return; }
    else if (variant.value && !variant.selectedOptions?.[0]?.disabled) selected.set(id, {
      productId: id, variantId: variant.value, title: card.dataset.royalMin3Title,
      handle: card.dataset.royalMin3Handle, variantTitle: variant.tagName === 'SELECT' ? variant.selectedOptions[0].textContent : ''
    });
    message('');
    render();
  });
  render();
})();
(() => {
  if (!document.querySelector('[data-royal-min3]')) return;

  document.querySelectorAll('.header__heading-link').forEach((logo) => {
    logo.removeAttribute('href');
    logo.removeAttribute('tabindex');
  });
})();
